import React from 'react';

import { ScreenWithOptionalParams, TabNavigationContextProvider } from 'core/navigation';
import { AnalyticsContextProvider } from '../../analytics';
import { CaseScreenContainer } from '../../component';
import { CaseNavigator, CASE3_ROUTE } from '../../navigation';

interface ScreenState
  extends Readonly<{
    tabs: string[];
    screens: ScreenWithOptionalParams[];
  }> {}

const createInitialState = (): ScreenState => {
  const initialState: ScreenState = {
    tabs: ['Overview', 'Challenges', 'Benefits'],
    screens: [{ screen: CASE3_ROUTE.OVERVIEW }, { screen: CASE3_ROUTE.CHALLENGES }, { screen: CASE3_ROUTE.BENEFITS }],
  };

  return initialState;
};

const INITIAL_SELECTED_TAB_INDEX = 0;

export const Case3Screen = React.memo(() => {
  const [state] = React.useState<ScreenState>(() => createInitialState());

  return (
    <TabNavigationContextProvider screens={state.screens} initialSelectedScreenIndex={INITIAL_SELECTED_TAB_INDEX}>
      <AnalyticsContextProvider>
        <CaseScreenContainer tabs={state.tabs}>
          <CaseNavigator />
        </CaseScreenContainer>
      </AnalyticsContextProvider>
    </TabNavigationContextProvider>
  );
});
